import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-05cf31a5"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["src"]
const _hoisted_2 = { class: "btnGroup" }
const _hoisted_3 = /*#__PURE__*/_createTextVNode("开始答题")

import { Dialog } from "vant"
import { usePageStore } from "@/store"
import { Button as VanButton } from "vant"
import "vant/es/button/style"
import 'vant/es/toast/style'
import 'vant/es/dialog/style'
import 'vant/es/skeleton/style'

// 显示活动说明

export default /*#__PURE__*/_defineComponent({
  __name: 'HomePage',
  setup(__props) {


const pageStateStore = usePageStore()

function showInfo() {
  Dialog.alert({
    title: "问答说明",
    message: pageStateStore.$state.pageInfo.collect?.content.replace(/<\/p>/g,"\r\n").replace(/<.+>/g,"")
  })
}

// 开始答题
function startGame() {
  pageStateStore.changePage(2)
}


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: "wrap",
    style: _normalizeStyle({
  backgroundImage: `url(${_unref(pageStateStore).pageInfo.collect?.info_cover_image})`
})
  }, [
    _createElementVNode("img", {
      class: "btImg",
      src: _unref(pageStateStore).$state.pageInfo.collect?.bt_image,
      onClick: showInfo,
      alt: "loading"
    }, null, 8, _hoisted_1),
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_unref(VanButton), {
        class: "btn start",
        type: "primary",
        size: "large",
        onClick: startGame
      }, {
        default: _withCtx(() => [
          _hoisted_3
        ]),
        _: 1
      })
    ])
  ], 4))
}
}

})